import * as React from 'react'

function SvgArrowDropdown(props, svgRef) {
  return (
    <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M1.414 0C.524 0 .077 1.077.707 1.707l4.586 4.586a1 1 0 001.414 0l4.586-4.586c.63-.63.184-1.707-.707-1.707H1.414z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgArrowDropdown)
export default ForwardRef
